import * as d3 from "d3";
import * as utils from "../utils/utils.js";


export function render(data){

    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "columnplot" && d.column == 2)
        .each(function(d){
            let plot = d3.select(`#${d.parentId}-columnplot`);
            plot.selectAll(".axis-y").remove();
            plot.selectAll(".no-data-message").remove();

            d.scale.y = d3.scaleLinear().domain(d3.extent(data.map(e=>e.y))).range([d.innerHeight, 0]).nice()
            const line = d3.line()
                .x(e => d.scale.x(e.x))
                .y(e => d.scale.y(e.y))

            let plotData = data.filter(e=> e._info.cl == d._userInput.key).sort((a,b)=> {
                return  d.scale.x.domain().indexOf(a.x) -  d.scale.x.domain().indexOf(b.x);
            });
     
            let nest = d3.groups(plotData, d => d.c)
                .sort((a, b) => d3.ascending(a[0], b[0])); // sorts guide keys

          
                let determineYTickValues = ()=>{

                    let values = [d.scale.y.domain()[0], d.scale.y.domain()[1]]
                    if (d.scale.y.domain()[1]<0){
                        values = [d.scale.y.domain()[0], d.scale.y.domain()[1]]
                    } else if (d.scale.y.domain()[1] == 0 ){
                        values = [d.scale.y.domain()[0], d.scale.y.domain()[1]]
                    }
                    else {
                        values = [d.scale.y.domain()[0], 0, d.scale.y.domain()[1]]
                    }
                    return values
                }
            var yAxis = d3.axisLeft()
                .scale(d.scale.y)
                .tickValues(determineYTickValues())
                .tickSizeInner(-d.innerWidth)

            plot.append("g").attr("class", "axis axis-y")
                .attr("transform", `translate(0,0)`)
                .call(yAxis)
                .selectAll("line").filter(d=>d==0).classed("dashed-line", true)
                .selectAll("text")
                .attr("dy", (e)=>{
                    if (e==d.scale.y.domain()[0]){ return 0 }
                    else if (e==d.scale.y.domain()[1]) { return 7 }
                    else { return 4 }
                })
                .filter(e=>e==0.0)
                .html("0")

            let lines =   plot.selectAll(`.line`).data(nest)
            lines.exit().remove()
            lines.enter().append("path").merge(lines)
                .attr("d", e=> line(e[1]))
                .attr("fill", "none")
                .attr("class", `line`)
                .attr("transform", `translate(${d.scale.x.bandwidth()/2}, 0)`)
                .style("stroke", (e, i)=>{
                    return utils.colors[i]                 
                })

                if (data.length == 0){
                    plot.selectAll(".axis-y").remove();
                    plot.append("text")
                        .html("No data")
                        .attr("x", d.padding.left)
                        .attr("y", d.innerHeight/2)
                        .attr("class", "no-data-message")
                }
        })

}


export function clear(){
    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "columnplot" && d.column == 2)
        .each(function(d){
            let plot = d3.select(`#${d.parentId}-columnplot`);
            plot.selectAll(".axis-y").remove();
            plot.selectAll(".no-data-message").remove();
            plot.selectAll(`.line`).remove();
        })
}

export function axis(){
    d3.selectAll(".ljs--lattice-plot")
    .filter(d=> d.type == "columnplot" && d.column == 2)
    .each(function(d){

        let plot =  d3.select(`#${d.parentId}-columnplot`)
        d.scale = {
            x: d3.scaleBand().domain(d._userInput.axis.x.domain).range([0, d.innerWidth])
        }  
        var x = d3.axisBottom()
            .scale(d.scale.x)
            .tickSizeInner(d.innerHeight);           
       
        plot.append("g").attr("class", "axis axis-x")
            .attr("transform", `translate(0,0)`)
            .call(x)
            .selectAll("text")
            .attr("text-anchor", "middle")
            .html(e=>utils.dict().condition[e])

        if (d.row==0){
            plot.append("text").html("Log2 (RPM)")
                .attr("class", "sm-axis-title")
                .attr("transform", `rotate(-90)`)
                .attr("x", -d.innerHeight/2)
                .attr("y", -d.padding.left*.8)
                .attr("text-anchor", "middle")

            plot.append("text").html("Condition")
                .attr("class", "sm-axis-title")
                .attr("x", d.innerWidth/2)
                .attr("y", d.innerHeight + (d.padding.bottom/1.5))
              
                .attr("text-anchor", "middle")
        }
       
    })
}